import { Logo } from "@/components/Logo";
import { SITE, scrollToId } from "@/lib/site";
import { MapPin, Mail, Headphones } from "lucide-react";

const QUICK = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "products", label: "Products" },
  { id: "services", label: "Services" },
  { id: "infrastructure", label: "Infrastructure" },
  { id: "contact", label: "Contact" },
];

const SOLUTIONS = [
  "OFC Cables",
  "Network Equipment",
  "Fiber Leasing",
  "Co-location",
  "RF Links",
  "Civil Works",
  "Telecom Infrastructure",
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-navy-900">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Logo />
            <p className="mt-5 text-sm leading-relaxed text-slate-400">
              {SITE.footerTagline}
            </p>
            <span className="mt-5 inline-flex items-center gap-2 rounded-full border border-cyan-400/25 bg-cyan-400/10 px-4 py-1.5 font-mono text-[11px] font-semibold tracking-[0.18em] text-cyan-300">
              <span className="h-1.5 w-1.5 rounded-full bg-cyan-400" />
              24/7 SUPPORT | 365 DAYS
            </span>
          </div>

          <nav aria-label="Footer quick links">
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-slate-500">
              Quick Links
            </p>
            <ul className="mt-5 space-y-2.5">
              {QUICK.map((q) => (
                <li key={q.id}>
                  <button
                    data-testid={`footer-link-${q.id}`}
                    onClick={() => scrollToId(q.id)}
                    className="text-sm text-slate-400 transition-colors duration-200 hover:text-cyan-300"
                  >
                    {q.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-slate-500">
              Solutions
            </p>
            <ul className="mt-5 space-y-2.5">
              {SOLUTIONS.map((s) => (
                <li key={s} className="text-sm text-slate-400">
                  {s}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-slate-500">
              Contact
            </p>
            <ul className="mt-5 space-y-3.5 text-sm text-slate-400">
              <li className="flex items-start gap-2.5">
                <MapPin size={15} className="mt-0.5 shrink-0 text-cyan-400" />
                {SITE.address}
              </li>
              <li>
                <a
                  data-testid="footer-email-link"
                  href={`mailto:${SITE.email}`}
                  className="flex items-center gap-2.5 transition-colors hover:text-cyan-300"
                >
                  <Mail size={15} className="shrink-0 text-cyan-400" />
                  {SITE.email}
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <Headphones size={15} className="shrink-0 text-cyan-400" />
                24/7 Support | 365 Days
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/[0.07] pt-7 sm:flex-row">
          <p className="text-xs text-slate-500">© 2026 JAYTRIKA. All Rights Reserved.</p>
          <p className="font-mono text-[11px] tracking-[0.2em] text-slate-600">
            CONNECTING TODAY. BUILDING TOMORROW.
          </p>
        </div>
      </div>
    </footer>
  );
}
